import { useNavigate } from "react-router-dom";
import Garden1      from "./images/Garden1.jpeg";
import Garden5      from "./images/Garden5.jpg";
import Garden4      from "./images/Garden4.jpeg";
import GarvanaHome8 from "./images/GarvanaHome8.png";
import HardscapeFeatures    from "../../Comon/Images/HardscapeFeatures.jpeg";
import IndoorHomePlants     from "../../Comon/Images/IndoorHomePlants.jpg";
import MeditationGardens    from "../../Comon/Images/MeditationGardens.jpeg";
import "./AboutUs.css";
import SEO from "../SEO/SEO";

const offerings = [
  "Landscape Architecture & Master Planning",
  "3D Garden Visualisation & Design Rendering",
  "Villa, Farmhouse & Estate Garden Design",
  "Terrace, Rooftop & Balcony Gardens",
  "Corporate, Resort & Hospitality Landscaping",
  "Township & Residential Society Landscaping",
  "Indoor Plant Décor & Biophilic Design",
  "Vertical Green Walls & Moss Panels",
  "Water Features — Fountains, Ponds & Waterfalls",
  "Pergola, Gazebo & Outdoor Structures",
  "Garden Pathway, Paving & Hardscape Design",
  "Outdoor Lighting & Ambience Design",
  "Drip, Sprinkler & Smart Irrigation Systems",
  "Lawn Creation & Premium Grass Carpeting",
  "Exotic, Rare & Native Plant Curation",
  "Fruit Orchard, Herb & Kitchen Gardens",
  "Tree Plantation & Long-Term Care",
  "Year-Round Garden Maintenance Contracts",
  "Pest, Disease & Soil Health Management",
  "Premium Plant Nursery — 500+ Varieties",
];

const reasons = [
  {
    title: "Expert Team",
    desc:  "Trained horticulturists and landscape architects with 10+ years of hands-on experience.",
  },
  {
    title: "Premium Quality",
    desc:  "Only the finest plants, materials, and techniques — we never compromise on quality.",
  },
  {
    title: "Eco-Friendly",
    desc:  "Organic, sustainable practices that respect the environment and your long-term wellbeing.",
  },
  {
    title: "Bespoke Designs",
    desc:  "Every garden is unique — we create fully personalised outdoor spaces tailored to you.",
  },
  {
    title: "End-to-End Service",
    desc:  "From concept and 3D visualisation to installation, maintenance, and ongoing support.",
  },
  {
    title: "On-Time Delivery",
    desc:  "We commit to timelines and deliver every project with precision and accountability.",
  },
];

export default function AboutUs() {
  const navigate = useNavigate();

  return (
    <div className="about">
      <SEO path="/about" />

      {/* ── HERO ── */}
      <div className="about__hero">
        <img src={Garden1} alt="Garvaana Landscape" className="about__hero-img" />
        <div className="about__hero-overlay" />
        <div className="about__hero-content">
          <span className="about__hero-tag">✦ Our Story</span>
          <h1 className="about__hero-title">
            About Garvaana <em>Enterprise</em>
          </h1>
        </div>
      </div>

      {/* ── STORY ── */}
      <section className="about__story">
        <div className="about__story-inner">

          <div className="about__story-text">
            <span className="about__story-label">Who We Are</span>
            <h2 className="about__story-title">
              Creating Green Spaces,<br />
              <em>Enriching Lives</em>
            </h2>
            <span className="about__story-divider" />
            <p>
              Welcome to <strong>Garvaana Enterprise</strong> — a trusted name in luxury landscape
              design, nursery, and comprehensive garden management. With over{" "}
              <strong>5 years of horticultural excellence</strong>, we transform outdoor and indoor
              spaces into lush, eco-friendly environments that enrich daily life and elevate property
              value.
            </p>
            <p>
              We combine creativity, technical expertise, and a deep love for nature to deliver
              premium landscaping solutions for homes, offices, villas, resorts, farmhouses, and
              commercial properties across Delhi NCR.
            </p>
            <p>
              Our team has delivered outstanding projects across Noida, Gurugram, Ghaziabad,
              Faridabad, and beyond — trusted by architects, hotel groups, and discerning private
              clients alike.
            </p>
            <button
              className="about__why-btn"
              onClick={() => navigate("/contact")}
              style={{ marginTop: "32px" }}
            >
              Start Your Project ✦
            </button>
          </div>

          <div className="about__story-images">
            <div className="about__story-img-grid">
              <img src={HardscapeFeatures} alt="Garden Design"  className="about__img about__img--tall" />
              <img src={IndoorHomePlants}      alt="Landscape Work" className="about__img" />
              <img src={MeditationGardens}      alt="Garden Project" className="about__img" />
            </div>
          </div>

        </div>
      </section>

      {/* ── OFFERINGS ── */}
      <section className="about__offerings">
        <div className="about__offerings-inner">

          <div className="about__offerings-header">
            <span className="about__offerings-tag">Full Spectrum of Services</span>
            <h2 className="about__offerings-title">
              What We <em>Offer</em>
            </h2>
            <p className="about__offerings-subtitle">
              From soil to skyline — every green solution, beautifully executed.
            </p>
            <span className="about__offerings-divider" />
          </div>

          <div className="about__offerings-grid">
            {offerings.map((item, i) => (
              <div className="about__offering-item" key={i}>
                <span className="about__offering-dot" />
                <span>{item}</span>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section className="about__why">
        <div className="about__why-inner">

          <div className="about__why-header">
            <span className="about__why-tag">Why Garvaana</span>
            <h2 className="about__why-title">
              The Garvaana <em>Difference</em>
            </h2>
            <p className="about__why-subtitle">
              Delivering high-quality, nature-rich outdoor spaces with a commitment to excellence
              across Delhi NCR.
            </p>
          </div>

          <div className="about__why-grid">
            {reasons.map((item, i) => (
              <div className="about__why-card" key={i}>
                <span className="about__why-num">0{i + 1}</span>
                <h3 className="about__why-card-title">{item.title}</h3>
                <p className="about__why-card-desc">{item.desc}</p>
              </div>
            ))}
          </div>

          <div className="about__why-cta">
            <p>
              Let's bring your <em>dream garden</em> to life.
            </p>
            <button
              className="about__why-btn"
              onClick={() => navigate("/contact")}
            >
              Get Started Today ✦
            </button>
          </div>

        </div>
      </section>

    </div>
  );
}